/* ═══════════════════════════════════════════════════════════
   Dayli Wellness Co. — theme script
   Ported from daylihome_24. Hash routing is gone (Shopify gives
   every page a real URL); phase copy and asset URLs now come from
   Liquid via window.DAYLI, set in layout/theme.liquid.
   ═══════════════════════════════════════════════════════════ */
(function () {
  const D = window.DAYLI || {};
  const PHASE = D.phase || 'waitlist';

  // ---- header shadow on scroll ----
  const header = document.getElementById('header');
  if (header) {
    addEventListener('scroll', () => header.classList.toggle('scrolled', scrollY > 8), { passive: true });
  }

  // ---- reveal on scroll ----
  const io = new IntersectionObserver((entries) => {
    for (const e of entries) if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
  }, { threshold: .15 });
  const observeReveals = (root) => (root || document).querySelectorAll('.reveal:not(.in)').forEach(el => io.observe(el));
  observeReveals();
  // inside the theme editor, sections re-render — reveal them straight away
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('.reveal').forEach(el => el.classList.add('in')));
  }

  // ---- gallery lanes: marquee until the visitor takes the wheel ----
  document.querySelectorAll('.world__track').forEach(t => {
    if (t.parentElement.classList.contains('world__lane')) return;
    const lane = document.createElement('div');
    lane.className = 'world__lane';
    t.parentNode.insertBefore(lane, t);
    lane.appendChild(t);
  });
  document.querySelectorAll('.world').forEach(w => {
    let resumeT;
    const manual = () => {
      w.classList.add('world--manual');
      clearTimeout(resumeT);
      resumeT = setTimeout(() => w.classList.remove('world--manual'), 5000);
    };
    w.addEventListener('wheel', e => { if (Math.abs(e.deltaX) > Math.abs(e.deltaY) * 1.5 && Math.abs(e.deltaX) > 8) manual(); }, { passive: true });
    w.addEventListener('touchstart', manual, { passive: true });
    w.querySelectorAll('.world__lane').forEach(l => {
      let down = false, sx = 0, sl = 0, moved = false;
      l.addEventListener('pointerdown', e => { down = true; moved = false; sx = e.clientX; sl = l.scrollLeft; });
      addEventListener('pointermove', e => {
        if (!down) return;
        if (Math.abs(e.clientX - sx) > 6) { manual(); moved = true; }
        if (moved) l.scrollLeft = sl - (e.clientX - sx);
      });
      addEventListener('pointerup', () => down = false);
    });
  });

  // ---- gentle parallax on any [data-parallax] image ----
  if (!matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const px = document.querySelectorAll('[data-parallax]');
    addEventListener('scroll', () => {
      px.forEach(img => {
        const r = img.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > innerHeight) return;
        const p = (r.top + r.height / 2 - innerHeight / 2) / innerHeight;
        img.style.transform = `translateY(${p * -img.dataset.parallax}px)`;
      });
    }, { passive: true });
  }

  // ---- mobile menu ----
  const burger = document.getElementById('burger');
  const mobileMenu = document.getElementById('mobileMenu');
  if (burger && mobileMenu) {
    burger.addEventListener('click', () => {
      const open = mobileMenu.classList.toggle('mobilemenu--open');
      burger.classList.toggle('nav__burger--open', open);
      burger.setAttribute('aria-expanded', open);
    });
  }

  // ---- desktop dropdown menu ----
  const navMenu = document.getElementById('navMenu');
  const navMenuBtn = document.getElementById('navMenuBtn');
  if (navMenu && navMenuBtn) {
    const setMenu = open => {
      navMenu.classList.toggle('navmenu--open', open);
      navMenuBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    };
    navMenuBtn.addEventListener('click', e => { e.stopPropagation(); setMenu(!navMenu.classList.contains('navmenu--open')); });
    document.addEventListener('click', e => { if (!navMenu.contains(e.target)) setMenu(false); });
    document.addEventListener('keydown', e => { if (e.key === 'Escape') setMenu(false); });
  }

  // ---- toast ----
  const toast = document.getElementById('toast');
  let toastT;
  function showToast(msg) {
    if (!toast) return;
    toast.textContent = msg;
    toast.classList.add('toast--on');
    clearTimeout(toastT);
    toastT = setTimeout(() => toast.classList.remove('toast--on'), 3200);
  }
  window.dayliToast = showToast;
  const fill = (tpl, name) => (tpl || '').replace(/\{\{\s*name\s*\}\}/g, name);

  // ---- waitlist modal (Phase 1) ----
  const wlModal = document.getElementById('wlModal');
  const wlForm = document.getElementById('wlForm');
  const wlProduct = document.getElementById('wlProduct');
  const wlTags = document.getElementById('wlTags');
  let wlName = D.defaultName || 'the jars';
  const openWaitlist = (name, tag) => {
    if (!wlModal) return;
    wlName = name || wlName;
    if (wlProduct) wlProduct.textContent = wlName + ' is';
    if (wlTags) wlTags.value = ['waitlist', tag ? 'waitlist-' + tag : ''].filter(Boolean).join(', ');
    wlModal.hidden = false;
    setTimeout(() => { const i = wlModal.querySelector('input[type=email]'); i && i.focus(); }, 40);
  };
  const closeWaitlist = () => { if (wlModal) wlModal.hidden = true; };
  if (wlModal) {
    const c = document.getElementById('wlClose');
    c && c.addEventListener('click', closeWaitlist);
    wlModal.addEventListener('click', e => { if (e.target === wlModal) closeWaitlist(); });
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && !wlModal.hidden) closeWaitlist(); });
  }

  // Shopify customer forms (waitlist + newsletter) — submit in place, no reload.
  // If Shopify answers with its spam challenge, we fall back to a normal submit.
  function ajaxCustomerForm(form, okMsg) {
    form.addEventListener('submit', async e => {
      if (form.dataset.native) return;         // second pass: let the browser submit
      e.preventDefault();
      const btn = form.querySelector('[type=submit]');
      const label = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = '…'; }
      try {
        const res = await fetch(form.action, { method: 'POST', body: new FormData(form), headers: { 'X-Requested-With': 'XMLHttpRequest' }, redirect: 'follow' });
        const url = res.url || '';
        if (/challenge/.test(url)) { form.dataset.native = '1'; form.submit(); return; }
        if (res.ok && (/customer_posted=true/.test(url) || /contact_posted=true/.test(url) || !/form_type/.test(url))) {
          form.reset();
          closeWaitlist();
          showToast(typeof okMsg === 'function' ? okMsg() : okMsg);
        } else {
          showToast(D.copy.error || 'Something slipped — try once more, sweet friend.');
        }
      } catch (err) {
        form.dataset.native = '1'; form.submit(); return;
      } finally {
        if (btn) { btn.disabled = false; btn.textContent = label; }
      }
    });
  }
  if (wlForm) ajaxCustomerForm(wlForm, () => fill(D.copy.waitlistToast, wlName));
  // after a full-page (non-AJAX) submit Shopify reloads the page — say thank you, or re-open on error
  if (window.DAYLI_POSTED === 'waitlist') showToast(fill(D.copy.waitlistToast, wlName));
  if (window.DAYLI_POSTED === 'newsletter') showToast(D.copy.newsletterToast);
  if (wlModal && wlModal.querySelector('.form__error')) wlModal.hidden = false;
  if (/customer_posted=true|contact_posted=true/.test(location.search)) history.replaceState(null, '', location.pathname + location.hash);
  document.querySelectorAll('form[data-newsletter]').forEach(f => ajaxCustomerForm(f, D.copy.newsletterToast || "You're on the list, sweet friend."));

  // ---- [data-add] buttons ----
  // waitlist phase: open the modal. preorder/launch: buttons inside a product
  // form add to cart; buttons elsewhere are plain links to the product page.
  document.querySelectorAll('[data-add]').forEach(b => b.addEventListener('click', ev => {
    if (PHASE === 'waitlist' || b.hasAttribute('data-waitlist')) {
      ev.preventDefault(); ev.stopPropagation();
      openWaitlist(b.dataset.add, b.dataset.tag);
    }
  }));

  // ---- product form: add to basket without leaving the page ----
  const bagEl = document.getElementById('bagCount');
  document.querySelectorAll('form[data-product-form]').forEach(form => {
    form.addEventListener('submit', async e => {
      e.preventDefault();
      const btn = form.querySelector('[type=submit]');
      const label = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = '…'; }
      try {
        const res = await fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' } });
        if (!res.ok) { const j = await res.json().catch(() => ({})); throw new Error(j.description || j.message || 'Could not add'); }
        const cart = await fetch('/cart.js').then(r => r.json());
        if (bagEl) bagEl.textContent = cart.item_count;
        showToast(fill(D.copy.cartToast, form.dataset.name || 'That'));
      } catch (err) {
        showToast(err.message || D.copy.error);
      } finally {
        if (btn) { btn.disabled = false; btn.textContent = label; }
      }
    });
    // variant radios → price + id
    const priceEl = form.closest('.pdp__buybox')?.querySelector('.pdp__price');
    form.querySelectorAll('.buyopt input[type=radio]').forEach(r => r.addEventListener('change', () => {
      form.querySelectorAll('.buyopt').forEach(o => o.classList.toggle('buyopt--on', o.contains(r)));
      const idInput = form.querySelector('input[name=id]');
      if (idInput) idInput.value = r.value;
      if (priceEl && r.dataset.price) priceEl.innerHTML = r.dataset.price;
      const submit = form.querySelector('[type=submit]');
      if (submit && r.dataset.available !== undefined) {
        const avail = r.dataset.available === 'true';
        submit.disabled = !avail;
        submit.classList.toggle('pdp__soldout', !avail);
        if (!avail) submit.textContent = D.copy.soldOut || 'Sold out — join the waitlist';
        else submit.textContent = submit.dataset.label || submit.textContent;
      }
    }));
    // quantity stepper
    form.querySelectorAll('.pdp__qty').forEach(q => {
      const input = q.querySelector('input');
      q.querySelector('[data-minus]')?.addEventListener('click', () => input.value = Math.max(1, +input.value - 1));
      q.querySelector('[data-plus]')?.addEventListener('click', () => input.value = +input.value + 1);
    });
  });

  // ---- PDP gallery thumbs ----
  document.querySelectorAll('.pdp__thumbs').forEach(t => {
    t.addEventListener('click', e => {
      const btn = e.target.closest('[data-thumb]');
      if (!btn) return;
      const main = t.closest('.pdp__gallery').querySelector('.pdp__main');
      const img = main.querySelector('img');
      const todo = main.querySelector('.pdp__todo');
      if (btn.dataset.thumb === 'todo') {
        img.style.display = 'none'; if (todo) todo.style.display = 'grid';
      } else {
        img.style.display = 'block'; img.src = btn.dataset.src; if (btn.dataset.srcset) img.srcset = btn.dataset.srcset; else img.removeAttribute('srcset');
        if (todo) todo.style.display = 'none';
      }
      t.querySelectorAll('[data-thumb]').forEach(x => x.classList.toggle('on', x === btn));
    });
  });

  // ---- sticky add bar on product pages ----
  const bar = document.querySelector('.stickybar');
  const addBtn = document.querySelector('.pdp__add');
  if (bar && addBtn) {
    new IntersectionObserver(es => {
      es.forEach(e => bar.classList.toggle('stickybar--on', !e.isIntersecting && e.boundingClientRect.top < 0));
    }, { threshold: 0 }).observe(addBtn);
  }

  // ---- search overlay: quick links, Enter runs a real search ----
  const SEARCH_INDEX = D.search || [];
  const searchOv = document.getElementById('searchOv');
  const searchInput = document.getElementById('searchInput');
  const searchResults = document.getElementById('searchResults');
  let searchHits = SEARCH_INDEX;
  function renderSearch(q) {
    const t = q.trim().toLowerCase();
    searchHits = !t ? SEARCH_INDEX : SEARCH_INDEX.filter(it => (it.t + ' ' + it.d + ' ' + it.k).toLowerCase().includes(t));
    searchResults.innerHTML = (searchHits.length
      ? searchHits.map((it, i) => `<button class="searchov__item" data-si="${i}"><strong>${it.t}</strong><span>${it.d}</span></button>`).join('')
      : `<p class="searchov__empty">${D.copy.searchEmpty || 'Nothing in the pantry by that name.'}</p>`)
      + (t ? `<button class="searchov__item" data-sq="1"><strong>Search everything for “${q.trim().replace(/</g, '&lt;')}”</strong><span>↵</span></button>` : '');
  }
  function openSearch() { searchOv.hidden = false; searchInput.value = ''; renderSearch(''); setTimeout(() => searchInput.focus(), 40); }
  function closeSearch() { searchOv.hidden = true; }
  function goSearch(it) { location.href = it.h; }
  function fullSearch() { location.href = (D.searchUrl || '/search') + '?q=' + encodeURIComponent(searchInput.value.trim()); }
  if (searchOv && searchInput && searchResults) {
    document.querySelectorAll('[data-search]').forEach(a => a.addEventListener('click', e => { e.preventDefault(); openSearch(); }));
    document.getElementById('searchClose')?.addEventListener('click', closeSearch);
    searchOv.addEventListener('click', e => { if (e.target === searchOv) closeSearch(); });
    searchInput.addEventListener('input', () => renderSearch(searchInput.value));
    searchInput.addEventListener('keydown', e => {
      if (e.key !== 'Enter') return;
      if (searchHits.length && searchInput.value.trim()) goSearch(searchHits[0]);
      else if (searchInput.value.trim()) fullSearch();
    });
    searchResults.addEventListener('click', e => {
      const q = e.target.closest('[data-sq]'); if (q) return fullSearch();
      const b = e.target.closest('[data-si]'); if (b) goSearch(searchHits[+b.dataset.si]);
    });
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && !searchOv.hidden) closeSearch(); });
  }

  // ---- accordions ----
  document.addEventListener('click', e => {
    const h = e.target.closest('.acc__head');
    if (h) h.parentElement.classList.toggle('acc--open');
  });

  // ---- in-page anchors on the same page: smooth scroll ----
  document.addEventListener('click', e => {
    const a = e.target.closest('a[href*="#"]');
    if (!a) return;
    const url = new URL(a.href, location.href);
    if (url.pathname !== location.pathname || !url.hash) return;
    const el = document.getElementById(url.hash.slice(1));
    if (el) { e.preventDefault(); el.scrollIntoView({ behavior: 'smooth', block: 'start' }); history.replaceState(null, '', url.hash); }
  });
})();
